import loadable from '@loadable/component';

// 懒加载组件
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));
const DeliveryBalanceQuery2 = loadable(() => import('./deliveryBalanceQuery2/DeliveryBalanceQuery2'));
const DeliveryReturnQuery = loadable(() => import('./deliveryReturnQuery/DeliveryReturnQuery'));
const OrderDetailQuery = loadable(() => import('./orderDetailQuery/OrderDetailQuery'));
const OperationDeliveryReturnQuery = loadable(() => import('../supDelivery/operationDeliveryReturnQuery/OperationDeliveryReturnQuery'));
const DeliveryInvoiceManagement = loadable(() => import('./deliveryInvoiceManagement/DeliveryInvoiceManagement'));
const DeliveryQuery2308 = loadable(() => import('./deliveryQuery2308/DeliveryQuery'));
const DeliveryModify2308 = loadable(() => import('./deliveryQuery2308/deliveryModify/DeliveryModify'));
const DeliveryWithUpstreamQuery = loadable(() => import('./deliveryWithUpstreamQuery/DeliveryQuery'));
const DeliveryWithUpstreamModify = loadable(() => import('./deliveryWithUpstreamQuery/deliveryModify/DeliveryModify'));
const DeliveryDetailWithUpstreamQuery = loadable(() => import('./deliveryDetailWithUpstreamQuery/DeliveryDetailQuery'));
const DeliveryReturnWithUpstreamQuery = loadable(() => import('./deliveryReturnWithUpstreamQuery/DeliveryReturnQuery'));
const OperationDeliveryReturnWithUpstreamQuery = loadable(() => import('./operationDeliveryReturnWithUpstreamQuery/OperationDeliveryReturnQuery'));
const DeliveryInvoiceWithUpstreamManagement = loadable(() => import('./deliveryInvoiceWithUpstreamManagement/DeliveryInvoiceManagement'));
const DeliveryBalanceWithPurchaseQuery = loadable(() => import('./deliveryBalanceWithPurchaseQuery/DeliveryBalanceWithPurchaseQuery'));
const DeliveryInvoiceInputManagement = loadable(() => import('./deliveryInvoiceInputManagement/DeliveryInvoiceInputManagement'));
const DeliveryReturnDetailQuery = loadable(() => import('./deliveryReturnDetailQuery/DeliveryReturnDetailQuery'));

export const subRoutes = [
  {
    // 253002耗材发货单查询
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    // 耗材发货单明细修改
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    // 253005耗材发货单明细查询
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  },
  {
    // 258002销售结算对账单
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  },
  {
    // 258009销售结算对账单（备货）
    path: '/DeliveryBalanceQuery2',
    component: DeliveryBalanceQuery2
  },
  {
    // 253003 退货单查询确认
    path: '/DeliveryReturnQuery',
    component: DeliveryReturnQuery
  },
  {
    path: '/OrderDetailQuery',
    component: OrderDetailQuery
  },
  {
    // 253008 高值退货单确认
    path: '/OperationDeliveryReturnQuery',
    component: OperationDeliveryReturnQuery
  },
  {
    // 253004 发货单发票管理
    path: '/DeliveryInvoiceManagement',
    component: DeliveryInvoiceManagement
  },
  {
    // 253002 耗材发货单查询
    path: '/DeliveryQuery2308',
    component: DeliveryQuery2308
  },
  {
    // 253002 耗材发货单明细修改
    path: '/DeliveryModify2308',
    component: DeliveryModify2308
  },
  {
    // 292002 上游：普耗发货单管理
    path: '/DeliveryWithUpstreamQuery',
    component: DeliveryWithUpstreamQuery
  },
  {
    // 292002 上游：普耗发货单管理明细修改
    path: '/DeliveryWithUpstreamModify',
    component: DeliveryWithUpstreamModify
  },
  {
    // 292004 上游：普耗退货单确认
    path: '/DeliveryReturnWithUpstreamQuery',
    component: DeliveryReturnWithUpstreamQuery
  },
  {
    // 292005 上游：高值退货单确认
    path: '/OperationDeliveryReturnWithUpstreamQuery',
    component: OperationDeliveryReturnWithUpstreamQuery
  },
  {
    // 292006 上游：发货单发票管理
    path: '/DeliveryInvoiceWithUpstreamManagement',
    component: DeliveryInvoiceWithUpstreamManagement
  },
  {
    // M292008 上游：发货明细查询
    path: '/DeliveryDetailWithUpstreamQuery',
    component: DeliveryDetailWithUpstreamQuery
  },
  {
    // M258010 供应商：销售结算对账单（集采标志）
    path: '/DeliveryBalanceWithPurchaseQuery',
    component: DeliveryBalanceWithPurchaseQuery
  },
  {
    // M253015 进项票管理
    path: '/DeliveryInvoiceInputManagement',
    component: DeliveryInvoiceInputManagement
  },
  {
    // M253016-供应商：退货明细查询
    path: '/DeliveryReturnDetailQuery',
    component: DeliveryReturnDetailQuery
  }
];
